export default "__VITE_ASSET__TZgFoqZQ__"